module.exports = __webpack_public_path__ + "static/media/19.7b700a77.jpg";